import { render, staticRenderFns } from "./LabCategory.vue?vue&type=template&id=1e3bb18a&"
import script from "./LabCategory.vue?vue&type=script&lang=js&"
export * from "./LabCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports